<template>
  <!-- 添加活动模板 -->
  <div class="addTemplate">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="rigth" label-width="100px"
        :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="商品名称" prop="title">
            <el-input v-model="addForm.title" clearable></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
        <el-form-item label="内容" prop="content">
            <!-- <wang-editor :value="addForm.content" @change="change"></wang-editor> -->
            <tinymce :value="addForm.content" @input="change" :isEditorLoad="isEditorLoad"></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-left:100px;">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureModify">确 定</el-button>
      </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'addTemplate',
  data() {
    return {
      id: '',
      //推荐商品 位置类型 状态 排序
      addForm:{
        title:"",
        content:"",
      },
      /**新增表单规则 */
      addFormRule:{
        title: [mustFill],
        content: [mustFill]
      },
      isClear: false,
      isEditorLoad: false // 编辑器是否加载完成
    }
  },
  components: {
    Tinymce
  },
  mounted(){
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams.id) {
      this.id = prams.id
      this.getDetail()
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    /**富文本编辑内容改变回调 */
    change(val) {
      this.addForm.content = val
    },
    // 获取详细信息
    getDetail(){
      this.$requestSys({
        method: "post",
        url: "Template/ashx/ReturnJson.ashx?type=TemplateDetail&strwhere=" + this.id,
        dataType: "json"
      }).then((res) => {
        let strs = res.split("|||")
        this.addForm.title = strs[0]
        this.addForm.content = strs[1]
        this.isEditorLoad = true
      }).catch((err) => {
        window.console.log(err)
      });
    },
    // 提交表单信息
    sureModify(){
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let data = {
            type: "SaveTemplate",
            title: this.addForm.title,
            content: this.addForm.content,
            strwhere: this.id
          }
          this.$request({
            method: 'post',
            url: 'Prom/SaveTemplate',
            data: data
          }).then(res => {
            if(res.success){
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.goBack()
            }else{
              this.$message({
                message: this.message,
                type: 'error'
              })
            }
          }).catch(err => {
            console.log(err);
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.addTemplate{
  width: 100%;
  height: 100%;
}
</style>
